// export default {
//     path: '/',
//     name: 'Main',
//     meta: {
//         title: 'Главная',
//         forVisitors: true,
//         name: "theme-color",
//         content: "black"
//     },
//     component: () => import('@/views/index.vue'),
// }

export default {
    path: '/',
    name: 'Theme',
    meta: {
        title: 'Тема поздравления',
        forVisitors: true,
        name: "theme-color",
        content: "black"
    },
    component: () => import('@/views/theme/index.vue'),
}